'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('basePensionModule', function($compile) {
  return {
    restrict: 'E',
    scope: {
      moduleData: '='
    },
    templateUrl: 'scripts/directives/otpp-pension-modules/base-pension-module.prt.html',
    link: {
      pre: function(scope, element) {
        scope.header = scope.moduleData.header;
        scope.headerAsClass = scope.header.replace('.', '-');
        scope.moduleName = scope.moduleData.moduleName;
        scope.text = scope.moduleData.text;
        scope.button = scope.moduleData.button;
        scope.href = scope.moduleData.href;
        scope.hasAlert = scope.moduleData.alertType !== null;
        scope.alertCount = scope.moduleData.alertCount;
        scope.attributes = scope.moduleData.attributes;
        scope.headerHref = scope.moduleData.headerHref;
        scope.trackAlertClicked=(isButtonClick)=>{
          isButtonClick==true?
            generateAdobeAlertReportEvent('click',1,scope.moduleData.alertType)
            :generateAdobeAlertReportEvent('click',scope.alertCount,scope.moduleData.alertType);
        }
        

        if (scope.hasAlert) {
          scope.alertType = scope.moduleData.alertType;
          generateAdobeAlertReportEvent('impression',scope.alertCount,scope.moduleData.alertType);
        } else {
          var directiveNode = document.createElement('otpp-' + scope.moduleData.moduleName + '-module');
          var compiledNode = $compile(directiveNode)(scope);
          element.find('.contentgroup').append(compiledNode);
        }
      }
    }
  };
});
